module.exports = "/_next/static/images/LCTL-124430e7009b30e26370572edf7222a9.svg";